import React, { forwardRef, ReactNode } from 'react';
import classNames from 'classnames';
import { Collapsible } from 'ncoded-component-library';
import ChevrondownIcon from 'icons/Chevrondown.icon';
import {
  CollapsibleProps,
  CollapsibleRef,
} from 'ncoded-component-library/build/components/molecules/Collapsible/Collapsible.component';

import './CollapsibleSection.styles.scss';

type CollapsibleSectionProps = {
  children: ReactNode;
  onTriggerClick?: () => void;
} & CollapsibleProps;

const CollapsibleSection: React.ForwardRefRenderFunction<
  CollapsibleRef,
  CollapsibleSectionProps
> = ({ children, trigger, className, onTriggerClick, ...rest }, ref) => (
  <Collapsible
    className={classNames('collapsible-section', className)}
    ref={ref}
    trigger={
      <div
        className="trigger"
        {...(onTriggerClick && { onClick: onTriggerClick })}
      >
        {trigger}
        <div className="trigger__action-buttons">
          <ChevrondownIcon />
        </div>
      </div>
    }
    {...rest}
  >
    {children}
  </Collapsible>
);

export default forwardRef(CollapsibleSection);
